export default "__VITE_ASSET__BICiURTw__"